import StandardQueryTable from "@/components/StandardQueryTable";
import { Module, PATH_DICTS_PAYROLL_TYPES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import i18n from "@/i18n";
import PayrollTypeCreator from "@/modules/payrollTypes/components/PayrollTypeCreator";
import PayrollTypeEditor from "@/modules/payrollTypes/components/PayrollTypeEditor";
import { PROJECT_DEPENDENCY_DEPARTMENT } from "@/schemas/commonFields";
import { createPayrollType, readPayrollType } from "@/schemas/payrollType";
import { PayrollTypesService } from "@/services/payrollType";
import { ReadPayrollType, WritePayrollType } from "@/types/payrollType";
import { Row } from "@tanstack/react-table";
import { FolderClockIcon } from "lucide-react";

const id = Module.PayrollTypes;
const path = PATH_DICTS_PAYROLL_TYPES;
const ns = "payrollTypes";

const config: DictionaryConfig<ReadPayrollType, WritePayrollType> = {
  id,
  ns,
  service: PayrollTypesService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: createPayrollType,
  excludeFromDefaultMenu: true,
  defaultValues: {
    name: "",
    description: "",
    split: false,
    project_depends_on: PROJECT_DEPENDENCY_DEPARTMENT,
    invoicing_company_id: "",
    administrative_fee: undefined,
    deduction_percentage: undefined,
  },
  Icon: FolderClockIcon,
  List: () => (
    <StandardQueryTable<ReadPayrollType>
      schema={readPayrollType}
      name={ns}
      fetchList={PayrollTypesService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.PayrollTypes },
      }}
      columnOverrides={{
        project_depends_on: {
          id: "project_depends_on",
          cell: ({ row }: { row: Row<ReadPayrollType> }) =>
            i18n.t(`projectDependsOn.${row.original.project_depends_on}`),
        },
        deduction_percentage: {
          id: "deduction_percentage",
          header: `${ns}.fields.deduction_percentage`,
        },
      }}
    />
  ),
  Creator: PayrollTypeCreator,
  Editor: PayrollTypeEditor,
};

export default config;
